import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "../../environments/environment";

@Injectable()
export class PersonalDetailsService {
  headers;
  constructor(private http: HttpClient) {}

  getHeaders() {
    this.headers = new HttpHeaders({
      "Content-Type": "application/json",
      Accept: "application/json",
      "access-token": localStorage.getItem("access-token"),
      client: localStorage.getItem("client"),
      clientid: localStorage.getItem('client_id'),
      expiry: localStorage.getItem("expiry"),
      uid: localStorage.getItem("uid"),
    });
  }

  createPersonalDetails(value) {
    this.getHeaders();
    return this.http.post(
      `${environment.offboarding_url}/personal_details_form`,
      value,
      {
        headers: this.headers,
        observe: "response",
      }
    );
  }

  updatePersonalDetails(value) {
    this.getHeaders();
    return this.http.put(
      `${environment.offboarding_url}/verify_details`,
      value,
      {
        headers: this.headers,
        observe: "response",
      }
    );
  }

  getPersonalDetails(id: number) {
    this.getHeaders();
    return this.http.get(
      `${environment.offboarding_url}/personal_details_form/${id}`,
      {
        headers: this.headers,
        observe: "response",
      }
    );
  }

  getPersonalDetailsForm() {
    this.getHeaders();
    return this.http.get(
      `${environment.offboarding_url}/questions?category=personal_details`,
      {
        headers: this.headers,
        observe: "response",
      }
    );
  }

  //exit-form below
  getForm() {
    this.getHeaders();
    return this.http.get(
      `${environment.offboarding_url}/questions?category=exit_form`,
      {
        headers: this.headers,
        observe: "response",
      }
    );
  }

    //exit-checklist below
    getForm2() {
      this.getHeaders();
      return this.http.get(
        `${environment.offboarding_url}/questions?category=exit_checklist_employee`,
        {
          headers: this.headers,
          observe: "response",
        }
      );
    }

  getAnswer(id) {
    this.getHeaders();
    return this.http.get(
      `${environment.offboarding_url}/exit_details/${id}?category=personal_details`,
      {
        headers: this.headers,
        observe: "response",
      }
    );
  }
  
}



// WEBPACK FOOTER //
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/services/personal-details.service.ts